import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setRoute('whs_stocktaking_evaluation'),
    MenuEntry.create()
        .setRoute('stocktaking_bin')
        .setAdditionalRoutes([
            'stocktaking_bin_evaluation',
        ]),
];
